<template>
  <div class="bg-chart">
    <global-loading v-if="$store.state.kpiStore.sla_loading" />
    <div class="responden">
      <div class="text-bold label-chart">Responden</div>

      <div class="doughnat-container">
        <pie-chart :chartData="chartData" :options="chartOptions" :styles="{ height: '75%', listStyleType: 'none' }"
          v-if="tiket" />
        <div class="chart-text-center">
          {{ chartData['datasets'][0]['data'][0] }}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
  },
  data() {
    return {
      labels: ['Responden'],
      chartData: {
        labels: ['Sudah Mengisi', 'Tidak Mengisi'],
        datasets: [
          {
            backgroundColor: ['red', '#808080'],
            data: [0, 100],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontSize: 10,
            boxWidth: 12,
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.labels[tooltipItem.index]
              const value = data.datasets[0].data[tooltipItem.index]
              const total = data.datasets[0].data.reduce((a, b) => a + b, 0)
              return `${label}: ${value}%`
            },
          },
        },
      },
    }
  },
  computed: {
    tiket() {
      const ticket = this.$store.state.kpiStore.tiket_selesai
      this.setChart()

      return ticket
    },
  },
  created() {
    this.setChart()
  },
  methods: {
    setChart() {
      const responden =
        Number(this.$store.state.kpiStore.responden) +
        Number(this.$store.state.kpiStore.system_responden)
      const not_yet = Number(this.$store.state.kpiStore.not_yet_assessed)
      const ticket = Number(this.$store.state.kpiStore.tiket_selesai)

      const totalMengisi = Math.round((responden / ticket) * 100)
      const totalTidak = Math.round((not_yet / ticket) * 100)

      if (responden >= 0 && not_yet >= 0) {
        this.chartData = {
          labels: ['Sudah Mengisi', 'Tidak Mengisi'],
          datasets: [
            {
              backgroundColor: ['red', '#808080'],
              data: [totalMengisi, totalTidak],
            },
          ],
        }
      } else {
        this.chartData = {
          labels: ['Sudah Mengisi', 'Tidak Mengisi'],
          datasets: [
            {
              backgroundColor: ['red', '#808080'],
              data: [0, 100],
            },
          ],
        }
      }
    },
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 50%;
  height: 20vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-chart {
  width: 45%;
  margin: 0 0 0 1rem;
}

.chart-text-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
}

.bg-chart {
  background-color: rgb(237, 231, 231);
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 1px 5px 3px gray;
}

.responden {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  padding: 1rem 0;
}
</style>
